import MainLayout from '@/pages/Layout/MainLayout.vue'

const CasesList = () => import('@/pages/cases/CaseList.vue')
const CaseDetail = () => import('@/pages/cases/Case.vue')
const CaseMember = () => import('@/pages/cases/CaseMember.vue')
const CaseDoc = () => import('@/pages/cases/CaseDoc.vue')

export default {
  path: '/case',
  component: MainLayout,
  redirect: '/case/list',
  children: [
    { path: 'list', component: CasesList },
    { path: ':caseId', props: true, component: CaseDetail },
    { path: ':caseId/doc/:docId', props: true, component: CaseDoc },
    { path: ':caseId/member/:memberId', props: true, component: CaseMember },
    { path: ':caseId/member/new', props: true, component: CaseMember }
  ]
}
